import { useEffect } from 'react';
import * as serviceWorkerRegistration from '../serviceWorkerRegistration';

export const usePWAUpdate = () => {
  useEffect(() => {
    serviceWorkerRegistration.register({
      onUpdate: (reg: ServiceWorkerRegistration) => {
        const sw = reg.waiting ?? navigator.serviceWorker.controller;
        sw?.postMessage({ type: 'CLEAR_ALL_CACHES' });

        if (reg.waiting && reg.waiting.state === 'installed') {
          navigator.serviceWorker.addEventListener('controllerchange', () => {
            window.location.reload();
          }, { once: true });
          reg.waiting.postMessage({ type: 'SKIP_WAITING' });
          setTimeout(() => window.location.reload(), 3000);
        } else {
          setTimeout(() => window.location.reload(), 300);
        }
      },
    });
  }, []);
};
